<template>
  <div id="Success" class="slideUp">
    <div class="content">
      <i class="anyteachicon anyteach-check-circle red animated bounce" />
      <h1>支付成功</h1>
      <h2 @click="end()">查看课程</h2>
    </div>
  </div>
</template>
<script>
export default {
  name: "Success",
  data() {
    return {}
  },
  methods: {
    end() {
      document.getElementById("Success").classList.remove("slideUp")
      document.getElementById("Success").classList.add("slideDown")
      setTimeout(() => {
        this.$emit("close")
      }, 300)
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";

#Success {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: white;
  overflow: scroll;
  z-index: 997;
  display: block;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .content {
    color: $black;
    text-align: center;
    i {
      font-size: 40px;
      margin-bottom: 10px;
    }
    h1 {
      font-size: 25px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 15px;
      font-weight: 300;
      margin-bottom: 80px;
    }
  }
}
</style>
